const EventEmitter = require('events');

const _XSSI_PREFIX = ")]}'";

class PanoLoader extends EventEmitter {
  constructor() {
    super();
    this.scale = 1.0;
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';

      img.addEventListener('load', (e) => {
        resolve(img);
      });
      img.addEventListener('error', () => {
        reject(new Error(`Failed to load image's URL: ${url}`));
      });
      img.src = url;
    });
  }

  getUrl(panoID) {
    const url = `https://streetviewpixels-pa.googleapis.com/v1/photo?cb_client=arts_and_culture.cilex&format=jpeg&minw=4000&photoid=${panoID}`;
    return url;
  }

  loadPanorama(panoID) {
    const url = this.getUrl(panoID);

    this.loadImage(url)
      .then((img) => {
        this.emit('complete', {
          image: img,
          scale: this.scale,
        });
      })

      .catch((error) => {
        console.error(error);
      });
  }

  getInformation(panoID, onSuccess) {
    const url = `https://cbk0.google.com/cbk?output=json&panoid=${panoID}&dm=0&cb_client=arts_and_culture`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => onSuccess(data));
  }

  getMetadata(panoID, callback = null) {
    let url =
      'https://www.google.com/maps/photometa/v1?pb=!1m4!1sarts_and_culture!11m2!2m1!2b1!3m3!1m2!1e2!2s' +
      panoID +
      '!4m4!1e1!1e2!1e3!1e4';
    fetch(url).then((res, err) => {
      if (err) {
        console.log('error while loading the metadata', err);
        this.emit('metadata', null);
        if (callback !== null) return callback();
        return;
      }

      res.text().then((txt) => {
        //don't judge... (the response is basically a black box)
        let content = txt.replace(_XSSI_PREFIX, '');
        while (content.charAt(0) !== '[') {
          content = content.substring(1);
        }
        const bits = JSON.parse(content);
        if (
          !Array.isArray(bits) ||
          bits.length < 2 ||
          !Array.isArray(bits[1]) ||
          !bits[1].length ||
          !Array.isArray(bits[1][0]) ||
          bits[1][0].length < 6 ||
          !Array.isArray(bits[1][0][5]) ||
          bits[1][0][5].length < 2 ||
          !Array.isArray(bits[1][0][5][1]) ||
          bits[1][0][5][1].length < 2 ||
          !Array.isArray(bits[1][0][5][1][1]) ||
          bits[1][0][5][1][1].length < 3
        ) {
          this.emit('metadata', null);
          if (callback !== null) {
            return callback(null);
          }
          return false;
        }

        const panoData = bits[1][0][5][1][1];

        // as long as we get this:
        // the lat/lon of the pano
        const lalo = panoData[0];
        const latitude = lalo[2];
        const longitude = lalo[3];

        // the orientation angles
        const angles = panoData[2];
        const heading = angles[0];
        const pitch = angles[1];
        const roll = angles[2];

        // computes the metadata
        const RAD = Math.PI / 180;
        const metadata = {
          Location: {
            panoId: panoID,
            lat: latitude,
            lng: longitude,
          },
          Orientation: {
            heading: RAD * (180 + heading),
            pitch: RAD * (90 - pitch),
            roll: RAD * roll,
          },
          status: 'OK',
        };

        this.emit('metadata', metadata);
        if (callback !== null) return callback(metadata);
        return metadata;
      });
    });
  }
}
export default PanoLoader;
